export const getWidth = (day, mode) => {
    switch (mode) {
        case 'day':
            return (day - 1) * 24 + 1;
        case 'week':
            return (day - 1) * 11;
        case 'month':
            return (day - 1) * 7;
        default:
            return (day - 1) * 24 + 1;
    }
};

export const getWidthPosition = (day, mode) => {
    switch (mode) {
        case 'day':
            return (day - 1) * 24 + 23;
        case 'week':
            return (day - 1) * 11 + 10;
        case 'month':
            return (day - 1) * 7 + 6;
        default:
            return (day - 1) * 24 + 1;
    }
};
